import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { useReminderDialog } from './ReminderDialog'
import { useState } from 'react'
import { apiPost, apiPatch } from '~/util/api'
import { useTranslation } from '~/hooks/useTranslation'

export const useReminderForm = ({ candidateId, reminder }) => {
  const {
    reminders,
    setReminders,
    toggleShowAddReminderDialog,
    initialText,
    documentId,
    skillName,
    savedCourse,
    setStatus,
    setReminder,
  } = useReminderDialog()

  const { t } = useTranslation('reminder_dialog')
  const [submitted, setSubmitted] = useState(false)
  const [loadingStatus, setLoadingStatus] = useState(null)

  const schema = {
    due_date: z.union([z.date(), z.null(), z.string()]),
    content: z.string().min(2, {
      message: t('please_add_a_reminder'),
    }),
    author_id: z.number(),
    saved_course_id: z.number().optional(),
  }

  const savedCourseDefaults = savedCourse
    ? { saved_course_id: savedCourse.id }
    : {}

  const defaultValues = {
    due_date: reminder?.due_date?.replace(/-/g, '/') || null,
    content: reminder?.content || initialText || '',
    author_id: candidateId,
    ...savedCourseDefaults,
  }

  const form = useForm({
    resolver: zodResolver(z.object(schema)),
    defaultValues,
  })

  async function onSubmit(values) {
    setSubmitted(true)
    setLoadingStatus('saving')

    const baseUrl = '/reminders'

    const savedCourseData = savedCourse
      ? { saved_course_id: savedCourse.id }
      : {}

    const data = {
      reminder: {
        due_date: values.due_date,
        content: values.content,
        author_id: values.author_id,
        document_id: documentId,
        skill_name: skillName,
        ...savedCourseData,
      },
    }

    const response = reminder
      ? await apiPatch(`${baseUrl}/${reminder.id}`, data)
      : await apiPost(baseUrl, data)

    if (response.status === 200 || response.status === 201) {
      if (savedCourse) {
        setStatus('reminder_created')
        setReminder(true)
      }
      setLoadingStatus('saved')
      if (reminder) {
        const updatedReminders = reminders.map((r) => {
          if (r.id === response.data.id) {
            return response.data
          } else {
            return r
          }
        })
        const sortedReminders = updatedReminders.sort((a, b) => {
          return new Date(a.due_date) - new Date(b.due_date)
        })
        setReminders(sortedReminders)
      } else {
        const newReminders = [...reminders, response.data]
        const sortedReminders = newReminders.sort((a, b) => {
          return new Date(a.due_date) - new Date(b.due_date)
        })
        setReminders(sortedReminders)
      }
      toggleShowAddReminderDialog()
      return response
    } else {
      console.log(response)
      console.log(response.status)
      console.log(response.error)
      throw new Error('res not ok')
    }
  }

  return { form, onSubmit, submitted, loadingStatus }
}
